<script>
  import FilterEventService from './filter-event-service.vue'

  export default {
    name: 'FilterEventDowntime',
    extends: FilterEventService,
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/filter-event-downtime.vue